export default __webpack_public_path__ + "static/media/maintenance.be2f1f44.png";